export default __webpack_public_path__ + "images/ebb59a84e5234cdae83230b7788e190c-Factrack.svg";